import React from 'react';
import Loadable from 'react-loadable';
import { Card, Skeleton } from 'antd';

const Loading = ({ error, timedOut, pastDelay, retry }) => {
  if (error) {
    return (
      <div>
        网络错误! <button onClick={retry}>重试</button>
      </div>
    );
  }
  if (timedOut) {
    // When the loader has taken longer than the timeout
    return (
      <div>
        超时... <button onClick={retry}>重试</button>
      </div>
    );
  }
  if (pastDelay) {
    return (
      <Card>
        <Skeleton active />
      </Card>
    );
  }
  return null;
};

export default function AsyncComponent(importFunc) {
  // 按需加载配置
  return Loadable({
    loader: importFunc,
    loading: Loading,
    // delay: 300,
    timeout: 10000,
  });
}
